import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import App from './App.tsx'
import './index.css'
import './i18n'
import { initializeVersion } from './config/version'
import { captureUtmParams } from './utils/utmCapture'

// Initialize PostHog IMMEDIATELY before anything else
posthog.init('phc_KfmdZ1n2pGzrhJNEZqATibY9D4ssvXIfLPP1Nyu6tXR', {
  api_host: 'https://p.equiphoto.ch',
  person_profiles: 'identified_only',
})

// Initialize version tracking on app startup
initializeVersion();

// Block right-click and image dragging site-wide (form fields keep their menu)
const isEditable = (t: EventTarget | null) =>
  t instanceof Element && !!t.closest('input, textarea, [contenteditable="true"], [contenteditable=""]');
document.addEventListener('contextmenu', (e) => {
  if (!isEditable(e.target)) e.preventDefault();
});
document.addEventListener('dragstart', (e) => {
  if (e.target instanceof HTMLImageElement) e.preventDefault();
});

// Capture UTM params from marketing emails
captureUtmParams();

createRoot(document.getElementById("root")!).render(<App />);

// Register WebMCP tools so AI agents can browse, build a cart and get a checkout link
import('./webmcp').then(({ initWebMcp }) => initWebMcp()).catch(() => {});
